import { Component, inject } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { environment } from '@qwyk/hub/environment';

@Component({
    selector: 'app-help-modal',
    templateUrl: './help-modal.component.html',
    styleUrls: ['./help-modal.component.scss'],
    standalone: true,
    imports: [TranslatePipe, FontAwesomeModule],
})
export class HelpModalComponent {
    env = environment;
    public feedbackSite: string = this.env.feedbackSite;
    public supportEmail: string = this.env.supportEmail;

    protected dialogRef = inject(DynamicDialogRef);

    public close() {
        this.dialogRef.close();
    }
}
